import { render, staticRenderFns } from "./u-language-items-icon.vue?vue&type=template&id=fcdc1b5c&scoped=true"
import script from "./u-language-items-icon.vue?vue&type=script&lang=js"
export * from "./u-language-items-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdc1b5c",
  null
  
)

export default component.exports